module.exports = __webpack_public_path__ + "img/dialogPng.5c3bf3f8.png";